import { LocalStorageUtils } from "utils/localstorage.utils";
import { makeApi } from "./callApi";

export class AreaApi {
  static async getAreaList() {
    const response = await makeApi(`/area`, "GET");
    return response.data;
  }

  static async getAreaById(areaId) {
    const response = await makeApi(`/area/${areaId}`, "GET");
    return response.data;
  }

  static async refreshAreaCache() {
    const areaId = LocalStorageUtils.getAreaId();
    if (areaId) {
      const area = LocalStorageUtils.getArea();
      if (area) {
        const lastCachedAt = area.cachedAt || 0;
        const now = new Date().getTime();
        const diffInMinutes = (now - lastCachedAt) / (1000 * 60);
        if (!lastCachedAt || diffInMinutes > 60 * 3) { // 3 hours
          try {
            console.log("Refreshing area cache", areaId, diffInMinutes);
            const response = await this.getAreaById(areaId);
            LocalStorageUtils.saveArea(response);
          } catch (error) {
            console.error(error);
          }
        } else {
          console.log("Area cache is still valid", areaId, diffInMinutes);
        }
      }
    }
  }
}
